var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscorddata(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 30,
    viewBox: "0 0 40 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.881 2.508A33.12 33.12 0 0 0 25.626 0a25.557 25.557 0 0 0-1.056 2.121c-3.035-.449-6.12-.449-9.154 0A21.462 21.462 0 0 0 14.359 0a33.45 33.45 0 0 0-8.254 2.516A32.689 32.689 0 0 0 .182 24.968 33.305 33.305 0 0 0 10.299 30a25.21 25.21 0 0 0 2.167-3.46 21.084 21.084 0 0 1-3.412-1.611c.282-.209.564-.418.83-.627a24.007 24.007 0 0 0 20.234 0c.273.224.547.433.829.627a21.398 21.398 0 0 1-3.411 1.61A23.997 23.997 0 0 0 29.695 30a33.321 33.321 0 0 0 10.125-5.025A32.712 32.712 0 0 0 33.88 2.508zm-20.523 17.93a4.031 4.031 0 0 1-4.006-2.15 3.947 3.947 0 0 1 .597-4.472 4.05 4.05 0 0 1 4.433-1.047 3.98 3.98 0 0 1 2.575 3.721c-.031 2.176-1.588 3.949-3.6 3.949zm13.301 0c-2.041-.218-3.588-1.924-3.588-3.955 0-2.032 1.547-3.737 3.588-3.957 1.01.046 1.96.492 2.636 1.237a3.707 3.707 0 0 1 .956 2.727c-.047 2.176-1.597 3.949-3.607 3.949h.015z",
    fill: "#231F20",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscorddata);
export default __webpack_public_path__ + "static/media/discorddata.1b389bdaff66e1f7f842359d92c0a23e.svg";
export { ForwardRef as ReactComponent };